export interface NetworkedGroupUpdateActions {
  update: () => Promise<unknown>;
  refresh: () => void;
  onSuccess: () => void;
  onConflict: () => void;
  onError: () => void;
}

export async function executeNetworkedGroupUpdate(
  actions: NetworkedGroupUpdateActions,
): Promise<"success" | "conflict" | "error"> {
  try {
    await actions.update();
    actions.onSuccess();
    return "success";
  } catch (error) {
    if (typeof error === "object" && error !== null && "status" in error && error.status === 409) {
      actions.refresh();
      actions.onConflict();
      return "conflict";
    }

    actions.onError();
    return "error";
  }
}
